<template>
  <text-metadata
    v-if="isTextMetadata"
    :name="name"
    :value="value"
    @input="update"
    :mandatory="metadataDefinition.mandatory"
  />
  <number-metadata
    v-else-if="isNumberMetadata"
    :name="name"
    :value="value"
    @input="update"
    :mandatory="metadataDefinition.mandatory"
    :digitNumber="metadataDefinition.digitNumber"
  />
  <date-metadata
    v-else-if="isDateMetadata"
    :name="name"
    :value="value"
    @input="update"
    :mandatory="metadataDefinition.mandatory"
  />
  <option-metadata
    v-else-if="isOptionMetadata"
    :name="name"
    :value="value"
    :valueOptions="metadataDefinition.valueOptions"
    @input="update"
    :mandatory="metadataDefinition.mandatory"
  />
</template>

<script>

import constants from '../../constants';

import DateMetadata from './DateMetadata';
import NumberMetadata from './NumberMetadata';
import OptionMetadata from './OptionMetadata';
import TextMetadata from './TextMetadata';

export default {
  name: 'Metadata',
  props: {
    name: {
      type: String,
    },
    metadataDefinition: {
      type: Object,
      required: true,
    },
    value: {
    },
  },
  components: {
    DateMetadata,
    NumberMetadata,
    OptionMetadata,
    TextMetadata,
  },
  watch: {
  },
  mounted() {
  },
  computed: {
    isNumberMetadata() {
      return this.metadataDefinition.type === constants.metadata.typeNumber;
    },
    isTextMetadata() {
      return this.metadataDefinition.type === constants.metadata.typeText;
    },
    isDateMetadata() {
      return this.metadataDefinition.type === constants.metadata.typeDate;
    },
    isOptionMetadata() {
      return this.metadataDefinition.type === constants.metadata.typeOption;
    },
  },
  methods: {
    isValid() {
      if (!this.metadataDefinition.mandatory) {
        return true;
      }
      
      return !!this.value;
    },
    update(newValue) {
      this.$emit('input', newValue);
    },
  },
  data() {
    return {
    };
  },
};
</script>
